
const imageURL = "../../../static/demoImage/"
export const logUrl = {
    home: imageURL+"home.png",
    applycard:imageURL+"查询进度.png",
    cat: imageURL+"公司展会DIY卡-01.png",
    dog: imageURL+"公司展会DIY卡-02.png",
    text_image: imageURL+"AI2.png",
    textandimage_image: imageURL+"AI3.png",
    image_image: imageURL+"AI1.png",
    image_upload: imageURL + "背景02.png",
    button01:imageURL+"button01.png",
    button02:imageURL+"button02.png",
    button03:imageURL+"button03.png",
    button04:imageURL+"button04.png",
    button05:imageURL+"button05.png",
    button06:imageURL+"button06.png",
    button07:imageURL+"button07.png",
    button08: imageURL + "button08.png",
    del:imageURL + "del.png",
    ele:imageURL + "ele.png",
    rotation_left01:imageURL + "左旋01.png",
    rotation_left02:imageURL + "左旋02.png",
    rotation_right01:imageURL + "右旋01.png",
    rotation_right02:imageURL + "右旋02.png",
    threeD_heng:imageURL + "横版背面.png",
    threeD_shu:imageURL + "竖版背面.png",
    zoom:imageURL + "双指缩放.png",
    // 
    lizi: imageURL+"lizi.png",
}


// WEBPACK FOOTER //
// ./src/common/logUrl.js